import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { TemporarilyCloseExamEventForm } from '../../components';

import {
  TemporarilyCloseExamEventFormSchema,
  type TemporarilyCloseExamEventFormType,
} from './schema';

interface TemporarilyCloseExamEventLogicProps {
  onSubmit: (reason: string) => void;
  onClose: () => void;
}

export default function TemporarilyCloseExamEventLogic(
  props: Readonly<TemporarilyCloseExamEventLogicProps>,
) {
  const { onSubmit, onClose } = props;

  const formContext = useForm<TemporarilyCloseExamEventFormType>({
    resolver: zodResolver(TemporarilyCloseExamEventFormSchema),
  });

  const handleSubmit = async (data: TemporarilyCloseExamEventFormType) => {
    onSubmit(data.reason);
    onClose();
  };

  return (
    <TemporarilyCloseExamEventForm form={formContext} onSubmit={handleSubmit} onClose={onClose} />
  );
}
